"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalutationSelect = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const legacy_1 = require("../Select/legacy");
const salutationItems = [
    {
        name: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Form/Field/SalutationSelect:Mr', defaultMessage: 'Mr.' })),
        value: 'mr',
    },
    {
        name: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Form/Field/SalutationSelect:Mrs', defaultMessage: 'Mrs.' })),
        value: 'mrs',
    },
];
const defaultSalutationItems = ['', ...salutationItems];
class SalutationSelect extends react_1.default.PureComponent {
    render() {
        return react_1.default.createElement(legacy_1.LegacyFormFieldSelect, { ...this.props });
    }
}
exports.SalutationSelect = SalutationSelect;
SalutationSelect.defaultProps = {
    items: defaultSalutationItems,
    placeholder: null,
};
//# sourceMappingURL=index.js.map